import React, { useState, useEffect } from 'react';

function TabView({ tabs, onChanged, isCenterAligned = true }) {
    const [activeTab, setActiveTab] = useState(tabs[0]?.key || "");

    const handleTabChange = (key) => {
        setActiveTab(key);
        if (onChanged) {
            onChanged(key); // Call the callback with the new active tab key
        }
    };

    // Notify the parent about the initial tab when the component mounts
    useEffect(() => {
        if (onChanged) {
            onChanged(activeTab);
        }
    }, [activeTab, onChanged]);

    return (
        <div className="w-full">
            {/* Tab Navigation */}
            <div className={`flex ${isCenterAligned ? "justify-center" : "justify-start"} border-b border-slate-800`}>
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        className={`px-4 py-2 text-sm font-medium text-gray-600 hover:text-slate-950 focus:outline-none ${activeTab === tab.key
                            ? "border-b-2 border-slate-800 text-slate-800"
                            : ""
                            }`}
                        onClick={() => handleTabChange(tab.key)}
                    >
                        {tab.title}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div className="mt-4">
                {tabs.map((tab) => (
                    <div
                        key={tab.key}
                        className={`${activeTab === tab.key ? "block" : "hidden"
                            }`}
                    >
                        {tab.content}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TabView;
